import React, { useState, useCallback, useEffect } from 'react';
import { handleStringFilterChange } from './filters';
import FilterListIcon from '@material-ui/icons/FilterList';
import DropdownMenuFilter from '../../DropdownMenu/DropdownMenuFilter.component';
import { useStyles } from './filters.styles';
import { FilterProps } from './filters.types';
import TooltipOne from '../../../components/TooltipOne/TooltipOne.component';
import { IconButton } from '@material-ui/core';

interface ProgressFilterProps<T> extends FilterProps<T> {
  valueName: string;
  initValue?: string | string[];
}

const convertInitValue = (initValue?: string | string[]): string[] => {
  if (!initValue || typeof initValue === 'string') return [initValue as string];
  return (initValue as string[]).map((x) => {
    if (x.includes('%')) return x;
    const split = x.split('-');
    if (split.length > 1) return `${split[0]}%-${split[1]}%`;
    return `${x}%`;
  });
};

export const ProgressFilter: React.FC<ProgressFilterProps<string>> = ({
  valueName,
  initValue,
  onChange,
  resetFilter,
}) => {
  const classes = useStyles();
  const [anchorElProgress, setAnchorElProgress] = useState<SVGSVGElement | HTMLElement | null>(null);
  const [progressFilter, setProgressFilter] = useState<string[]>(initValue ? [...convertInitValue(initValue)] : []);

  useEffect(() => {
    if (resetFilter) {
      setProgressFilter([]);
    }
  }, [resetFilter]);

  const handleProgressFilterChange = useCallback(
    (value?: string) => {
      handleStringFilterChange(
        progressFilter,
        (newFilters: string[]) => {
          setProgressFilter(newFilters);
          const convertedValue: string[] = newFilters.map((e) => e.replaceAll('%', ''));
          onChange(valueName, convertedValue);
        },
        value,
      );
    },
    [progressFilter],
  );

  const handleClickProgress = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    if (!anchorElProgress) {
      setAnchorElProgress(event.currentTarget);
    } else setAnchorElProgress(null);
  };

  return (
    <>
      <TooltipOne title="Ustaw filtr do wyszukiwania: Postęp" placement="top">
        <IconButton disableRipple aria-label={`Ikonka rozwijająca filtr wyszukiwania: Postęp`} size="small">
          <FilterListIcon
            className={progressFilter.length ? classes.activeFilter : ''}
            onClick={handleClickProgress}
            aria-controls="Progress-menu"
            aria-haspopup="true"
          />
        </IconButton>
      </TooltipOne>
      <DropdownMenuFilter
        anchorEl={anchorElProgress}
        setAnchorEl={setAnchorElProgress}
        menuItems={['0%-20%', '20%-40%', '40%-60%', '60%-80%', '80%-100%']}
        hasCheckbox={true}
        checkedItems={progressFilter}
        onChange={handleProgressFilterChange}
        uncheckAllMenuItems={handleProgressFilterChange}
      />
    </>
  );
};
